export default [
  {
    path: "/app/grovi",
    name: "group-interview",
    meta: {
      needToken: false,
      checkUa: true
    },
    component: () => import("./interview.vue")
  },
  {
    path: "/app/wait-grovi",
    name: "wait-group",
    meta: {
      needToken: false,
      checkUa: true
    },
    component: () => import("./wait.vue")
  },
  {
    path: "/app/group-guide",
    name: "group-guide",
    component: () => import("./guide.vue")
  },
  {
    path: "/group-list",
    name: "group-list",
    meta: {
      needToken: true,
      needCompany: true
    },
    component: () => import("./list")
  },
  {
    path: "/c-grovi",
    name: "create-group",
    meta: {
      needToken: true,
      needCompany: true
    },
    component: () => import("./create.vue")
  },
  {
    path: "/group-guide",
    redirect: "/app/group-guide"
  },
  {
    path: "/wait-grovi",
    redirect: "/app/wait-grovi"
  },
  {
    path: "/grovi",
    redirect: "/app/grovi"
  },
]


// WEBPACK FOOTER //
// ./src/content/group-interview/router.js